// Shared multi-select team (group) filter, rendered as one drop-down
// (`core/filter-select.ts`) like every other facet in the panel. The caller owns the
// selection set (module-level, so it survives re-renders) and supplies an `onChange`
// that re-applies the filter to its already-rendered rows (client-side, no refetch).
import { t } from '../ui/lang';
import { filterSelect, pickFilterSelect, wireFilterSelects } from './filter-select';
import { fetchTeams } from '../users/teams-shared';
/**
 * Populate `el` with the team filter. Teams come from GET /api/teams; failures (or no
 * teams) simply leave the filter empty and the list still loads. Drops stale selections
 * (ids that no longer exist). Returns the loaded teams.
 */
export async function buildTeamFilter(el, selected, onChange) {
    let teams = [];
    try {
        teams = await fetchTeams();
    }
    catch { /* no filter, list still renders */ }
    if (teams.length === 0)
        return teams;
    // Drop stale selections (teams that no longer exist).
    for (const id of [...selected]) {
        if (!teams.some((t) => t.id === id))
            selected.delete(id);
    }
    el.innerHTML = filterSelect(t('nav.teams'), 'teams', teams.map((tm) => ({
        key: String(tm.id), label: tm.name, on: selected.has(tm.id),
    })));
    if (el.dataset['wired'])
        return teams;
    el.dataset['wired'] = '1';
    wireFilterSelects(el);
    el.addEventListener('click', (e) => {
        const opt = e.target.closest('.fsel__opt');
        if (!opt || !el.contains(opt))
            return;
        const id = Number.parseInt(opt.dataset['key'] ?? '', 10);
        if (!id)
            return;
        if (pickFilterSelect(opt))
            selected.add(id);
        else
            selected.delete(id);
        onChange();
    });
    return teams;
}
/** True if a row with `teamId` passes the selection (empty selection = show all). */
export function teamFilterMatches(selected, teamId) {
    return selected.size === 0 || (teamId != null && selected.has(teamId));
}
